import { Controller } from "react-hook-form";
import PhoneInput from 'react-phone-input-2'
import "react-phone-input-2/lib/bootstrap.css";

const PersonalInfo = ({ register, errors, control }) => {
  return (
    <div className="d-flex flex-column bg-white p-3 rounded shadow-sm mb-2">
      <div className="d-flex">
        <h5 className="font-semibold text-lg">Personal Information</h5>
      </div>
      <div className="d-flex flex-wrap">
        <div className="w-50 p-1">
          <input
            {...register("fullName", { required: "Full Name is required" })}
            className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
            placeholder="Full Name"
          />
          {errors.fullName && (
            <div className="invalid-feedback">{errors.fullName.message}</div>
          )}
        </div>

        <div className="w-50 p-1">
          <input
            {...register("institution", {
              required: "Institution Name is required",
            })}
            className={`form-control ${errors.institution ? "is-invalid" : ""}`}
            placeholder="Institution Name"
          />
        </div>

        <div className="w-50 p-1">
            <input 
              {...register("officialRepresentative", { required: "Official Representative Name is required" })} 
              type="text" 
              className={`form-control ${errors.officialRepresentative ? "is-invalid" : ""}`} 
              placeholder="Name of Official Representative" 
            />
            {errors.officialRepresentative && <div className="invalid-feedback">{errors.officialRepresentative.message}</div>}
        </div>

        <div className="w-50 p-1">
          <input 
            {...register("email", { 
              required: "Email is required", 
              pattern: { 
                value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, 
                message: "Invalid email address" 
              } 
            })} 
            type="text" 
            className={`form-control ${errors.email ? "is-invalid" : ""}`} 
            placeholder="Email Address" 
          />
          {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
        </div>        
      </div>

      <div className=" p-1">
        <Controller
          control={control}
          name="phone"
          rules={{ required: 'Phone Number is required' }}
          render={({ field: { ref, ...field } }) => (
            <PhoneInput
              {...field}
              inputExtraProps={{
                ref,
                required: true,
              }}
              country={"id"}
              countryCodeEditable={false}
              inputClass={`form-control ${errors.phone && 'is-invalid'}`}
              inputStyle={{width:'100%', height: '45px'}}
            />
          )}
        />
        {errors.phone?.message && (<div className="text-invalids text-danger">{errors.phone.message}</div>) }
      </div>      
    </div>
  );
};

export default PersonalInfo;